import React, { useState } from 'react';
import { Button } from 'antd';
import CmsReleaseModalForm from '../../forms/CmsReleaseModalForm';
import ButtonHiddenWithInsufficientPermission from '../../../hocs/buttons/ButtonHiddenWithInsufficientPermission';

type Props = {
  isDisabled?: boolean;
};

const EnhancedButton = ButtonHiddenWithInsufficientPermission(Button);

const CmsReleaseCreateButton = ({ isDisabled }: Props) => {
  const [isModalShown, setIsModalShown] = useState(false);

  return (
    <>
      <EnhancedButton type="primary" disabled={isDisabled} onClick={() => setIsModalShown(true)}>
        Add New Release
      </EnhancedButton>
      <CmsReleaseModalForm
        isShown={isModalShown}
        setIsShown={setIsModalShown}
        modalTitle="Create Release"
      />
    </>
  );
};

export default CmsReleaseCreateButton;
